<template>
  <div :class="$style.root">
    <template v-if="isReady">
      <Form>
        <Title>
          我的帳戶
        </Title>
        <FormRow>
          <Input placeholder="電郵地址" :value="model('login').get()" disabled />
        </FormRow>
        <FormRow>
          <Input placeholder="名字" :value="model('name').get()" @input="(val) => model('name').set(val)" />
        </FormRow>
        <FormRow>
          <Input type="password" placeholder="更改密碼" v-model="password" />
        </FormRow>
        <Buttons>
          <NextButton
            @click="handleSubmit"
            :disabled="isLoading"
            :loading="isLoading"
          />
        </Buttons>
      </Form>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, email, sameAs } from 'vuelidate/lib/validators'
import Input from '@/components/Input'
import InputError from '@/components/InputError'
import NextButton from '@/components/NextButton'
import Links from '@/components/Landing/Links'
import Form from '@/components/Landing/Form'
import FormRow from '@/components/Landing/FormRow'
import Buttons from '@/components/Landing/Buttons'
import Title from '@/components/Landing/Title'
import isEmpty from 'lodash/isEmpty'
import isNil from 'lodash/isNil'

export default {
  mixins: [validationMixin],
  components: {
    Input,
    InputError,
    NextButton,
    Links,
    Form,
    FormRow,
    Buttons,
    Title,
  },
  data () {
    return {
      isLoading: false,
      dirtyAttrs: {},
      password: null,
    }
  },
  computed: {
    isReady () {
      return !!this.originalAttrs
    },
    ...mapGetters('auth', {
      originalAttrs: 'user',
    }),
  },
  methods: {
    model (name) {
      return {
        get: () => {
          return isNil(this.dirtyAttrs[name])
            ? this.originalAttrs[name]
            : this.dirtyAttrs[name]
        },
        set: (value) => {
          this.$set(this.dirtyAttrs, name, value)
        },
      }
    },
    reset () {
      this.dirtyAttrs = {}
      this.password = null
    },
    async handleSubmit () {
      const payload = { ...this.dirtyAttrs }
      if (this.password) {
        payload.password = this.password
      }

      if (isEmpty(payload)) {
        return
      }

      this.isLoading = true
      try {
        await this.updateProfile(payload)
        this.reset()
        this.$toasted.success('資料成功更新')
      } catch (e) {
        this.$toasted.error('輸入錯誤')
      } finally {
        this.isLoading = false
      }
    },
    ...mapActions('auth', {
      updateProfile: 'updateProfile',
    }),
  },
}
</script>

<style lang="scss" module>
.root {
  @apply w-full;
  @apply h-full;
  @apply flex;
  @apply justify-center;
}
</style>
